/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';

import Main from './pages/Main';
import Hub from './pages/Hub';
import Blocked from './pages/Blocked';
import Benchmark from './pages/Benchmark';
import DesktopTest from './pages/DesktopTest';
import SiteSolve from './pages/SiteSolve';

import * as consts from './constants';

class App extends Component {
  constructor() {
    super();

    // frame-react-app project on mixpanel
    mixpanel.init('9611c12e572e3b55217bbaaccffae320', {
      disable_persistence: true, // We don't request cookie perms, so disable peristant storage
    });
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Main accountID={consts.dashboardLiveAccount.id} />
          </Route>
          <Route exact path="/hub" component={Hub} />
          <Route exact path="/sitesolve" component={SiteSolve} />
          <Route exact path="/blocked" component={Blocked} />
          <Route exact path="/benchmark">
            <Benchmark accountID={consts.dashboardLiveAccount.id} />
          </Route>
          <Route exact path="/desktoptest" component={DesktopTest} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
